import LanguageNames from "@cospired/i18n-iso-languages";
// @ts-ignore
import EnglishLanguages from "@cospired/i18n-iso-languages/langs/en.json";
// @ts-ignore
import SpanishLanguages from "@cospired/i18n-iso-languages/langs/es.json";
// @ts-ignore
import DutchLanguages from "@cospired/i18n-iso-languages/langs/nl.json";

// We have to register the languages the library can use so we don't have to load all possible languages
// See https://www.npmjs.com/package/i18n-iso-countries for supported languages
LanguageNames.registerLocale(EnglishLanguages);
LanguageNames.registerLocale(SpanishLanguages);
LanguageNames.registerLocale(DutchLanguages);

export default LanguageNames;
